import { render, staticRenderFns } from "./PanelPayReceive.vue?vue&type=template&id=c25beade&scoped=true&"
import script from "./PanelPayReceive.vue?vue&type=script&lang=js&"
export * from "./PanelPayReceive.vue?vue&type=script&lang=js&"
import style0 from "./PanelPayReceive.vue?vue&type=style&index=0&id=c25beade&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c25beade",
  null
  
)

export default component.exports